import { render, staticRenderFns } from "./fee-discount-competences.component.vue?vue&type=template&id=08fcab38&scoped=true&"
import script from "./fee-discount-competences.component.vue?vue&type=script&lang=ts&"
export * from "./fee-discount-competences.component.vue?vue&type=script&lang=ts&"
import style0 from "./fee-discount-competences.component.vue?vue&type=style&index=0&id=08fcab38&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fcab38",
  null
  
)

export default component.exports